import React from 'react';

interface FixedActionsProps {
  children: React.ReactNode;
  className?: string;
  padding?: boolean;
}

const FixedActions: React.FC<FixedActionsProps> = ({ 
  children, 
  className = '',
  padding = true
}) => {
  return (
    <div
      className={`
        fixed-actions
        flex-shrink-0
        w-full
        ${padding ? 'px-6 pb-6 pt-4' : ''}
        ${className}
      `}
      style={{
        // Ensure buttons are accessible on all devices
        minHeight: '56px',
      }}
    >
      {children}
    </div>
  );
};

export default FixedActions; 